/**
 * Created with IntelliJ IDEA.
 * User: livnat
 * Date: 3/3/13
 * Time: 2:55 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
	"use strict";

	var LE = require("app");
	var Marionette = require("marionette");
	var _ = require("underscore");
    var Button = require("ui/button/Button");
    var Dropdown = require("ui/dropdown/Dropdown");
	var Gallery = require("ui.components/gallery/gallery");
	var template = require("src/components/gallery-service/templates/galleryView.tmpl");
	var DropdownMenu = require("ui/dropdown-menu/DropdownMenu");
    var Ellipsis = require("ui.plugins/ellipsis");
    var StepIndicator = require("ui/stepIndicator/StepIndicator");

    var FILTER_CONTAINERS = {
        MAIN: "filterContainer"
    };

    var ButtonsConfig = {
        cancelBtn: {

            type: Button,
            options: {
                el: "view.ui.cancelBtn",
                permutation: Button.PERMUTATION.LINK,
                text: LE.translator.translate("LEFramework.global.captions.cancel")
            },
            events: {
                "click": "_onCancel"
            }
        },
        backBtn: {

            type: Button,
            options: {
                el: "view.ui.backBtn",
                permutation: Button.PERMUTATION.BTN,
                text: LE.translator.translate("LEFramework.global.captions.back")
            },
            events: {
                "click": "_onBack"
            }
        },
        nextBtn: {
            type: Button,
            options: {
                el: "view.ui.nextBtn",
                permutation: Button.PERMUTATION.BTN,
                text: LE.translator.translate("LEFramework.global.captions.next")
            },
            events: {
                "click": "_onNext"
            }
        },
        doneBtn: {
            type: Button,
            options: {
                el: "view.ui.doneBtn",
                permutation: Button.PERMUTATION.BTN_PRIMARY,
                text: LE.translator.translate("LEFramework.global.captions.done")
            },
            events: {
                "click": "_onDone"
            }
        }

    };


    var GalleryView = Marionette.ItemView.extend({
        template: template,
        className: "gallery-view",

        initialize: function (options) {
            this.module = options.module;
            this.selectedItemId = options.selectedItemId;
            this.channel = options.channel;
            this.galleryCollection = options.galleryCollection;
            this.origSelectedItemId = options.origSelectedItemId;
            this.buttonOptions = options.buttonOptions;
            this.progressBarClass = options.progressBarClass ? options.progressBarClass : "hide";
            this.allowDuplicate = !!options.allowDuplicate;
            this.allowSetAsDefault = !!options.allowSetAsDefault;
            this.allowApiBasedWindow = !!options.allowApiBasedWindow;
            this.stepIndicatorOptions = options.stepIndicatorOptions;
            this.galleryFilters = options.galleryFilters;
            this.collectionMap = options.collectionMap || {};
            this.showDependencyTypeTitle = !!options.showDependencyTypeTitle;
            this.maxItemsToDisplay = options.maxItemsToDisplay;

            this.module.logger.info("Gallery initialized", "GalleryView:initialize");

        },

        ui: {
            actionMenuContainer: ".action-menu",
            galleryContainer: ".gallery-container",
            doneBtn: ".button-done",
            nextBtn: ".button-next",
            backBtn: ".button-back",
            cancelBtn: ".button-cancel",
            progressBar: ".progress-bar",
            totalItems: ".total-items-number",
            filterContainer: ".page-action-strip .gallery-filter-container"
        },

        uiComponents: {
            actionMenu:{
                type:DropdownMenu,
                options: "_getActionMenuOptions",
                events:{
                    "change": "_changeDropdownSelection"
                }
            },
            gallery: {
                type: Gallery,
                options: "_getGalleryOptions",
                events: {
                    "change": "_onGalleryItemClick",
                    "edit":   "_onGalleryItemEdit",
                    "view":   "_onGalleryItemView",
                    "dependencyClick": "_onGalleryItemDependencyClick"
                }
            },
            stepIndicator: {
                type: StepIndicator,
                options: "_getStepIndicatorOptions"
            }
        },
        customTemplateHelpers: function () {
            var footerContainerClassName = "gallery-view";
            if (!_.isUndefined(this.galleryCollection) && !_.isEmpty(this.galleryCollection.name)) {
                footerContainerClassName = this.galleryCollection.name.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
            }
            return {
                footerContainerClassName: footerContainerClassName
            };
        },
        onRender: function () {
            this.selectItemOnGallery(this.selectedItemId);
            this.uiComponents.gallery.scrollToSelectedItem();
            //we either do it here with deferred or on show( since the view can not know the parent is using region Show we do it here )
            _.defer(_.bind(function(){
                Ellipsis.handleNow(this);
            }, this));
            this.listenTo(this, "page:closeButtonClick", this._onCloseWindow);
            this._renderFilterComponents();
            this._renderButtons();

            this._updateTotalNumberOfItems();
            this.listenTo(this.galleryCollection, "add remove", this._updateTotalNumberOfItems);
        },
        _getGalleryOptions: function() {
            var options = {
                collection :"view.galleryCollection",
                collectionMap : "view.collectionMap",
                el :"view.ui.galleryContainer",
                newItemToAdd: {
                    name:LE.translator.translate("LEFramework.global.captions.addNew")
                },
                showDependencyTypeTitle: "view.showDependencyTypeTitle"
            };

            if (this.maxItemsToDisplay) {
                options.maxItemsToDisplay = this.maxItemsToDisplay;
            }

            return options;
        },
        _getStepIndicatorOptions: function(){
            if (!_.isUndefined(this.stepIndicatorOptions)){
                this.stepIndicatorOptions.el = this.ui.progressBar;
                this.stepIndicatorOptions.permutation = StepIndicator.PERMUTATION.G;
            }
            return this.stepIndicatorOptions;
        },
        _renderFilterComponents: function(){
            var nameId = 1;
            _.each(this.galleryFilters, _.bind(function(filter){
                if (_.has(filter, "items") && _.has(filter, "selectedId")) {
                    var name = filter.name || "filter_" + nameId;
                    var container = filter.container || FILTER_CONTAINERS.MAIN;
                    var permutation = filter.permutation || Dropdown.PERMUTATION.SMALL;
                    this.uiComponents.host$.createAndRender(name, {
                        type: Dropdown,
                        options: {
                            container: "view.ui." + container,
                            permutation: permutation,
                            items: this._getFilterItems(filter.items),
                            selectedOption: filter.selectedId
                        },
                        events: {
                            change: "_onFilterChange"
                        }
                    });
                    nameId++;
                }
                else {
                    this.module.logger.error("wrong filter configuration!", "GalleryView:_renderFilterComponents", filter);
                }
            }, this));
        },
        _renderButtons: function () {
            _.each(_.keys(ButtonsConfig),function(buttonName) {
                    if (_.has(this.buttonOptions,buttonName)){
                        this.uiComponents.host$.createAndRender(buttonName, {
                            type:    ButtonsConfig[buttonName].type,
                            options: _.extend(ButtonsConfig[buttonName].options, this.buttonOptions[buttonName]),
                            events:  ButtonsConfig[buttonName].events
                        });
                    }
                    else {
                        this.ui[buttonName].hide();
                    }

            },this);
        },
        selectItemOnGallery: function (itemId) {

            this.selectedItemId = itemId;
            if (this.galleryCollection.size() === 0) {
                this._toggleDropdownItems(null);
                return;
            }

            this.uiComponents.gallery.selectItem(this.selectedItemId);

            this._toggleDropdownItems(this._getSelectedModel());

        },

        _getFilterItems: function(itemsArray){
            var items = new Dropdown.Collection();
            _.each(itemsArray, function(item) {
                items.push({key: item.key, value: item.value});
            });

            return items;
        },

        _updateTotalNumberOfItems: function() {
            this.ui.totalItems.text(this.galleryCollection.size());
        },

        updateDependencies: function(dependenciesArr){
            this.uiComponents.gallery.updateDependencies(dependenciesArr);
        },

        _onFilterChange: function(componentId, eventName, valueObj){
            this.channel.trigger("GalleryView:filter:change", componentId, valueObj.selectedKey);
        },

        _onGalleryItemClick: function(componentId, eventName, value) {
            if (value === Gallery.NEW_ITEM_KEY) {
                this.module.logger.info("New gallery Item clicked", "GalleryView:onGalleryItemClick");
                this._create();
            }
            else {
                this.module.logger.info("Gallery selection changed", "GalleryView:onGalleryItemClick", {
                    selected: value
                });
                this.selectedItemId = value;
                this._toggleDropdownItems(this._getSelectedModel());
                this.channel.trigger("GalleryView:select",this.selectedItemId);
            }
        },
        _getSelectedModel: function(){
            return this.galleryCollection.get(this.selectedItemId) ;
        },
        _toggleDropdownItems: function(itemModel) {

            var editEnabled =  _.isEmpty(itemModel)? false : itemModel.isEditable();
            var setAsDefaultEnabled =  _.isEmpty(itemModel)? false : itemModel.canSetUserDefault();
            var deleteEnabled =  (_.isEmpty(itemModel) || itemModel.isUserDefault() || (itemModel.id === this.origSelectedItemId)) ? false : itemModel.isDeletable();
            var duplicateEnabled = _.isEmpty(itemModel) ? false : itemModel.isDuplicatable();
            var tooltipText = "";

            this.dropdownMenuOptionsItems.findWhere({id : "edit"}).set("enabled", editEnabled);
            this.dropdownMenuOptionsItems.findWhere({id : "delete"}).set("enabled", deleteEnabled);

            if (itemModel && itemModel.isUserDefault()) {
                tooltipText = LE.translator.translate("LEFramework.gallery.actions.errors.galleryItem.cannot.delete.default");
            }
            else if (itemModel && itemModel.id === this.origSelectedItemId) {
                tooltipText = LE.translator.translate("LEFramework.gallery.actions.errors.galleryItem.cannot.delete.item.assigned.to.entity");
            }
            this.dropdownMenuOptionsItems.findWhere({id : "delete"}).set("title", tooltipText);


            if (this.allowDuplicate) {
                    this.dropdownMenuOptionsItems.findWhere({id: "duplicate"}).set("enabled", duplicateEnabled);
            }
            var setAsDefaultMenuOptionItem = this.dropdownMenuOptionsItems.findWhere({id : "setAsDefault"});
            if (!_.isUndefined(setAsDefaultMenuOptionItem)){
                setAsDefaultMenuOptionItem.set("enabled", setAsDefaultEnabled);
            }
        },

        _onGalleryItemEdit: function(componentId, eventName, itemId) {
            this.module.logger.info("Edit gallery item clicked", "GalleryView:onGalleryItemEdit");
            this._edit(itemId);
        },
        _onGalleryItemView: function(componentId, eventName, itemId) {
            this.module.logger.info("View gallery item clicked", "GalleryView:onGalleryItemView");
            this._view(itemId);
        },

        _onGalleryItemDependencyClick: function(componentId, eventName, url) {
            this.module.logger.info("View gallery item dependency link clicked", "GalleryView:_onGalleryItemDependencyClick");
            this.channel.trigger("GalleryView:dependencyClick", url);

        },


        //----------------------------------------------------
        // Get action menu options.
        //----------------------------------------------------
        _getActionMenuOptions:function () {
            var menuOptions = [
                { id:'create', "actionName":LE.translator.translate("LEFramework.global.captions.add"), "enabled":true}
            ];
            if(this.allowApiBasedWindow){
                menuOptions.push({ id:'addApiBasedWindow', "actionName":LE.translator.translate("LEFramework.gallery.actions.addApiBasedWindow"), "enabled":true});
            }
            menuOptions.push({ id:'edit', "actionName":LE.translator.translate("LEFramework.global.captions.edit"), "enabled":true});
            menuOptions.push({ id:'delete', "actionName":LE.translator.translate("LEFramework.global.captions.delete"), "enabled":true, "align":"right"});
            if(this.allowDuplicate){
                menuOptions.push({ id:'duplicate', "actionName":LE.translator.translate("LEFramework.global.captions.duplicate"), "enabled":true});
            }
            if(this.allowSetAsDefault){
                menuOptions.push({ id:'setAsDefault', "actionName":LE.translator.translate("LEFramework.global.captions.setAsDefault"), "enabled":true});
            }
            this.dropdownMenuOptionsItems = new DropdownMenu.Collection(menuOptions);

            return {
                name      : LE.translator.translate("LEFramework.global.captions.action"),
                el        : this.ui.actionMenuContainer,
                collection: this.dropdownMenuOptionsItems,
                tabindex  : "1000",
                align: DropdownMenu.ALIGN.RIGHT
            };
        },

        //----------------------------------------------------
        // Handle change dropdown selection.
        //----------------------------------------------------
        _changeDropdownSelection: function(component, eventName, id){
            this.module.logger.info("GalleryView: user clicked on action: " + id, "GalleryView:changeDropdownSelection");

            switch (id) {
                case 'create':
                    this._create();
                    break;
                case 'edit':
                    this._edit();
                    break;
                case 'delete':
                    this._delete();
                    break;
                case 'duplicate':
                    this._duplicate();
                    break;
                case 'setAsDefault':
                    this._setAsDefault();
                    break;
                case 'addApiBasedWindow':
                    this._addApiBasedWindow();
                    break;
                default:
                    break;
            }
        },

        _create: function(){
            this.channel.trigger("GalleryView:create");
        },

        /**
         * Edit selected item - tell the controller
         */
        _edit: function(itemId){
            // take Edit Clicked itemId (editing from gallery item Edit link)
            if (_.isUndefined(itemId)) {
                // take selected itemId (editing from action menu)
                itemId = this.selectedItemId;
            }
            this.channel.trigger("GalleryView:edit",itemId);
        },
        /**
         * View selected item - called only from gallery not from menu
         * as defined by Tal - tell the controller
         */
        _view: function(itemId){
            this.channel.trigger("GalleryView:view",itemId);
        },

        _delete: function(){
            this.channel.trigger("GalleryView:delete",this.selectedItemId);
        },

        _duplicate: function(){
            this.channel.trigger("GalleryView:duplicate",this.selectedItemId);
        },

        _setAsDefault: function(){
            this.channel.trigger("GalleryView:setAsDefault",this.selectedItemId);
        },

        _addApiBasedWindow: function(){
            this.channel.trigger("GalleryView:addApiBasedWindow");
        },

        //----------------------------------------------------
        // Handle 'done' button clicked.
        //----------------------------------------------------
        _onDone: function(){
            this.module.logger.info("gallery: user clicked on done button.", "GalleryView:onDoneBtnClick");
            this.channel.trigger("GalleryView:done", this.selectedItemId);
        },

        _onCancel:function () {
            this.module.logger.info("gallery: user clicked on 'cancel' button.", "GalleryView:_onCancel");
            this.channel.trigger("GalleryView:cancel");
        },
        _onBack:function () {
            this.module.logger.info("gallery: user clicked on 'back' button.", "GalleryView:_onBack");
            this.channel.trigger("GalleryView:back");
        },
        _onNext:function () {
            this.module.logger.info("gallery: user clicked on 'next' button.", "GalleryView:_onNext");
            this.channel.trigger("GalleryView:next");
        },
        _onCloseWindow: function () {
            this.module.logger.info("gallery: user clicked on 'close window' button.", "GalleryView:_onCloseWindow");
            this.channel.trigger("GalleryView:closeWindow");
        },

        onClose: function () {
            this.module.logger.info("Gallery closed", "GalleryView:onClose");
        }
    });


    GalleryView.FILTER_CONTAINERS = FILTER_CONTAINERS;
	return GalleryView;
});

